import { clientMount } from '@vp/ubik-fragment-react'
import type { MountWithRootOptions } from '@vp/ubik-fragment-types'
import { Banner, type IBannerProps } from '../components/Banner/deals-banner'

export const mount: MountWithRootOptions<IBannerProps> = async (rootElement, renderProps, rootOptions) => {
  return clientMount(<Banner {...renderProps} />, rootElement, rootOptions)
}
